<template>
<!-- 省市区 -->
    <div class="modal" v-show="showMask">
        <div class="modal-bg"></div>
        <div class="modal-content" ref="monthPie" :style="type != 'normal' ? 'width:340px;height:'+height+'px;margin-left:-170px;' : widthStyle">
            <div class="modal-header">
                <span class="fl">{{title}}</span>
                <a class="close fr" href="javascript:void(0);" @click="closeMask"><img src="/static/images/close.png" class="db"/></a>
            </div>
            <div class="modal-warp">
                <slot name="mdBox"></slot>
            </div>
            <div class="modal-footer ac" v-if="modalFoot">
                <div v-if="type == 'alert'">
                    <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                </div>
                <div v-if="type != 'alert'">
                    <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                    <button class="btn btn-gray" id="closeModal" @click="closeMask">{{cancelText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dialog",
    props:{
        // dialogShow:{
        //     type:Boolean,
        //     default: true,
        // },
        title:{
            type:String,
            default:function(){
                return '提示';
            }, 
        },
        width:{
            type:String,
            default:function(){
                return '340';
            }, 
        },
        type:{
            type:String,
            default:function(){
                return 'normal';
            }, 
        },
        modalFoot:{
            type:Boolean,
            default: true,
        },
        btnText:{
            type:String,
            default:function(){
                return '确定';
            }, 
        },
        callback:{
            type:Function
        }
    },
    data() {
        return {
            showMask: false,
            timer:'',
            loadText:'请稍后.',
            widthStyle:'',
            height:'',
            cancelText:'取消',
        }
    },
    mounted() {
        // this.showMask = this.value;
        this.widthStyle = 'width:'+this.width+'px;margin-left:-'+this.width/2+'px';
    },
    created() {
		
    },
    methods: {
        //打开弹框
        showMaskFun () {
            let that = this;
            that.showMask = true;
            setTimeout(() => {
                let h = that.$refs.monthPie.offsetHeight;
                if(h%2 != 0){
                    h++;
                    that.height = h;
                }
                that.widthStyle = 'width:'+that.width+'px;height:'+that.height+'px;margin-left:-'+that.width/2+'px';
                // that.$refs.monthPie.offsetHeight = that.height;
            }, 10);
        },
        closeMask(){
            //clearInterval(this.timer);
            this.showMask = false;
            this.height = '';
            this.widthStyle = 'width:'+this.width+'px;margin-left:-'+this.width/2+'px';
            // $(".modal-content").height(this.height);
        },
        dangerBtn(){
            let that = this;
            // if(that.load == true){
            //     return;
            // }
            if(that.type === 'alert'){
                this.showMask = false;
                return;
            }
            let num = 0;
            this.callback();
            // setTimeout(() => {
            //     if(this.dialogShow == true){
            //         this.closeMask();
            //     }
            // }, 1);
        }
    }
}
</script>
<style lang="" scoped>
    .modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
    .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
    .modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);background:#fff;border-radius:4px;}
    .modal-header{height:45px;padding:0 16px;line-height:44px;border-bottom:1px solid #ddd;}
    .modal-header .close{width:20px;height:20px;margin:11px 0;cursor: pointer;}
    .modal-header .close img{margin:4px;}
    .modal-warp{padding:24px;}
    .modal-footer{padding:8px 0 24px;}
    .modal-footer .btn{min-width:92px;margin:0 8px;border:none}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue